import { Component } from '@angular/core';

import {
  ListContainerComponent,
  ListElementComponent,
  ListExtraInformationComponent,
  ListSubTitleComponent,
  ListTagComponent,
  ListTitleComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        ListContainerComponent,
        ListElementComponent,
        ListExtraInformationComponent,
        ListSubTitleComponent,
        ListTagComponent,
        ListTitleComponent,
        TestIdDirective,
    ],
    template: `
    <cam-list-container camTestId="cam-list-container">
      <cam-list-element camTestId="cam-list-element">
        <cam-list-title camTestId="cam-list-title">Element title</cam-list-title>
        <cam-list-sub-title camTestId="cam-list-sub-title">Element subtitle</cam-list-sub-title>
        <cam-list-tag camTestId="cam-list-tag">tag</cam-list-tag>
        <cam-list-extra-information camTestId="cam-list-extra-information">extra</cam-list-extra-information>
      </cam-list-element>
    </cam-list-container>
  `
})
export class UiListsCase {}
